import { useState, FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim()) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9u46blca23r0tr1aq80', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = {}; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，我们会定期为您推送精选育儿知识和优惠资讯。');
        setEmail('');
      } else {
        setStatus('error');
        const serverMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试';
        setMessage(serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请稍后重试');
    }
  };

  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20abstract%20pastel%20gradient%20background%20with%20gentle%20curves%2C%20cream%20and%20warm%20beige%20tones%2C%20minimalist%20elegant%20style%2C%20soft%20texture&width=1920&height=600&seq=newsletter-bg-mia&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-background-50/70"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          加入蜜芽妈妈社区
        </h2>
        <p className="text-foreground-600 text-sm mb-8">
          订阅我们的育儿资讯，第一时间获取精选育儿知识、优惠活动和品牌上新通知
        </p>

        {status === 'success' ? (
          <div className="bg-accent-100 text-accent-800 rounded-xl px-6 py-4 text-sm font-medium">
            {message}
          </div>
        ) : (
          <form onSubmit={handleSubmit} data-readdy-form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="visually-hidden" />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入您的邮箱地址"
              required
              className="flex-1 px-5 py-3.5 rounded-full bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
            />
            <button
              type="submit"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-full text-sm font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              立即订阅
            </button>
          </form>
        )}
        {status === 'error' && (
          <p className="text-red-500 text-sm mt-3">{message}</p>
        )}
      </div>
    </section>
  );
}